import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Guard
import { AuthGuard } from '../../auth/services/auth-guard.service';
import { AnonymousGuard } from '../../auth/services/anonymous-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [AnonymousGuard],
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: 'app/admin/admin.module#AdminModule'
  },
  {
    path: 'staff',
    canActivate: [AuthGuard],
    loadChildren: 'app/staff/staff.module#StaffModule'
  },
  {
    path: 'help-center',
    loadChildren: 'app/help-center/help-center.module#HelpCenterModule'
  }
];

export const Routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/core/routing/app.routing.ts